<div class="content">
    <div class="d-flex justify-content-start mt-2">

        <div (click)="goToCatalogView()" style="cursor: pointer;">
            <div class="d-flex align-items-center">
                <i class="fa-solid fa-arrow-left"></i>
                <span>Back to Catalogs</span>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
        <h2>Catalog</h2>
    </div>

    <div class="d-flex justify-content-center mt-4">
        <ng2-smart-table [settings]="settingsFilter" [source]="listCatalog">
        </ng2-smart-table>


    </div>
    <div class="d-flex justify-content-center mt-4">
        <h2>Tariffs</h2>
    </div>

    <div class="d-flex justify-content-center mt-4">
        <ng2-smart-table [settings]="settings" [source]="listTariff" (custom)="onCustomAction($event)">
        </ng2-smart-table>


    </div>

</div>